import Image from 'next/image';
import React, { ReactElement } from 'react';

import { Assets } from '../../../../../utils/assets';
import MaxWidth from '../../../../shared/MaxWidth';
import * as S from './Statements.styles';

export const Statements = (): ReactElement => {
  return (
    <MaxWidth style={{ position: 'relative' }}>
      <S.BackgroundPanel />
      <S.Wrapper>
        <S.Statement>
          <div>
            <Image
              alt={Assets.images.missionIcon.alt}
              height={36}
              src={Assets.images.missionIcon.url}
              width={49}
            />
          </div>
          <S.Caption>Our mission</S.Caption>
          <S.Description>
            <S.Accent>
              Our mission is to help people around the world unlock their full potential.
            </S.Accent>
            <p>
              Started as a focus-music company in 2014, Brain.fm has already grown to support users
              in all aspects of their lives, becoming a leading name in science-backed music.
              Brain.fm believes that different brains have different needs, and that understanding a
              person is key to helping them.
            </p>
          </S.Description>
        </S.Statement>
        <S.Statement>
          <div>
            <Image
              alt={Assets.images.visionIcon.alt}
              height={36}
              src={Assets.images.visionIcon.url}
              width={54}
            />
          </div>
          <S.Caption>Our vision</S.Caption>
          <S.Description>
            <p>
              The possibilities of noninvasive neurostimulation in the digital age are limitless,
              and extend beyond music. We are pushing toward adjustment of brain states through
              sound, light, and touch, as well as dynamic stimulation through biosensors.
            </p>
            <p>
              Radical personalization is essential, as is learning over time. For the first time in
              history we have the understanding and ability to shape our brain activity for the
              better, to support anyone, anywhere.
            </p>
          </S.Description>
        </S.Statement>
      </S.Wrapper>
    </MaxWidth>
  );
};
